import { observer } from 'mobx-react';

interface Props {
  purchased: number;
  activated: number;
  allocated: number;
}

function UsageBar({ activated, allocated, purchased }: Props) {
  const remaining = purchased - activated - allocated;
  return (
    <div className="flex w-full h-full">
      <div className="bg-green-600 h-full" style={{ flexGrow: activated }}></div>
      <div className="bg-gray-400 h-full" style={{ flexGrow: allocated }}></div>
      <div className="h-full" style={{ flexGrow: remaining < 0 ? undefined : remaining }}></div>
    </div>
  );
}

export default observer(UsageBar);
